var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Saving-Piggy-Coins--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Saving Piggy Coins Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.37 8.5h-0.46a0.26 0.26 0 0 1 -0.24 -0.19 8.35 8.35 0 0 0 -3.56 -4.94 0.26 0.26 0 0 1 -0.1 -0.28 3.09 3.09 0 0 1 0.8 -1.27 1 1 0 0 0 -0.44 -1.69 4 4 0 0 0 -4.2 1.47 0.24 0.24 0 0 1 -0.24 0.09A11.16 11.16 0 0 0 5 3.81a8.18 8.18 0 0 0 -2.93 4.51 0.27 0.27 0 0 0 0.06 0.23 0.24 0.24 0 0 0 0.22 0.08 23.13 23.13 0 0 1 2.78 -0.13c1.78 0 6.5 0 6.5 2.5v7.24a0.25 0.25 0 0 0 0.25 0.25 10.69 10.69 0 0 0 3.25 -0.49 0.25 0.25 0 0 1 0.19 0 0.23 0.23 0 0 1 0.12 0.15l0.49 1.68A1.49 1.49 0 0 0 17.37 21a1.4 1.4 0 0 0 0.41 -0.05 1.51 1.51 0 0 0 1 -1.86l-0.65 -2.24a0.26 0.26 0 0 1 0.1 -0.28 8.81 8.81 0 0 0 2.65 -2.89 0.25 0.25 0 0 1 0.22 -0.13h1.24a1.5 1.5 0 0 0 1.5 -1.5V10a1.5 1.5 0 0 0 -1.47 -1.5Zm-5.5 0a1 1 0 1 1 1 1 1 1 0 0 1 -1 -1Zm-9 -1.9a0.78 0.78 0 0 1 -0.45 0.15 0.74 0.74 0 0 1 -0.6 -0.3 0.75 0.75 0 0 1 0.15 -1 8.2 8.2 0 0 1 5.5 -1.63 0.76 0.76 0 0 1 0.7 0.8 0.77 0.77 0 0 1 -0.8 0.7A6.73 6.73 0 0 0 7.82 6.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.69a0.24 0.24 0 0 0 0.13 -0.22V13.1a0.25 0.25 0 0 0 -0.1 -0.2 0.24 0.24 0 0 0 -0.23 0 15.84 15.84 0 0 1 -4.67 0.63 15.73 15.73 0 0 1 -4.66 -0.63 0.23 0.23 0 0 0 -0.23 0 0.23 0.23 0 0 0 -0.11 0.2v2.38a0.25 0.25 0 0 0 0.14 0.22 11.75 11.75 0 0 0 4.86 0.8 11.59 11.59 0 0 0 4.87 -0.81Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13 21.5a15.73 15.73 0 0 1 -4.66 -0.63 0.23 0.23 0 0 0 -0.23 0 0.23 0.23 0 0 0 -0.11 0.2V23c0 0.55 2.24 1 5 1s5 -0.45 5 -1v-1.9a0.25 0.25 0 0 0 -0.1 -0.2 0.24 0.24 0 0 0 -0.23 0 15.84 15.84 0 0 1 -4.67 0.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13 11v0.48a0.25 0.25 0 0 0 0.14 0.22 11.75 11.75 0 0 0 4.86 0.8 11.59 11.59 0 0 0 4.87 -0.81 0.24 0.24 0 0 0 0.13 -0.22V11c0 -0.55 -2.24 -1 -5 -1s-5 0.45 -5 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.13 17.1a0.25 0.25 0 0 0 -0.1 -0.2 0.24 0.24 0 0 0 -0.23 0 15.84 15.84 0 0 1 -4.67 0.63 15.73 15.73 0 0 1 -4.66 -0.63 0.23 0.23 0 0 0 -0.23 0 0.23 0.23 0 0 0 -0.11 0.2v2.38a0.25 0.25 0 0 0 0.14 0.22 11.75 11.75 0 0 0 4.86 0.8 11.59 11.59 0 0 0 4.87 -0.81 0.24 0.24 0 0 0 0.13 -0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavings);
export default ForwardRef;